let layerConfig: LayerConfig = {
    // 默认放置区域高度
    defaultLayerHeight: 12.5,

    // 默认层板宽度
    defaultWidth: 30,

    // 默认层板厚度
    defaultModuleHeight: 4.5,
    keyMap: {
        spaceSize: 'cubeData.spaceSize',
        floorHeight: 'cubeData.floorHeight',
        layerNumber: 'cubeData.layerNumber',
        desc: 'cubeData.desc',

        //常规
        grouped: 'cubeData.moduleInstance.grouped',
        warning: 'cubeData.moduleInstance.warning',
        moduleType: 'cubeData.moduleInstance.moduleType',
        moduleTag: 'cubeData.moduleInstance.moduleTag',
        moduleName: 'cubeData.moduleInstance.moduleName',
        moduleWidth: 'cubeData.moduleInstance.moduleWidth',
        moduleHeight: 'cubeData.moduleInstance.moduleHeight',
        moduleDepth: 'cubeData.moduleInstance.moduleDepth',
        posX: 'cubeData.moduleInstance.posX',
        posY: 'cubeData.moduleInstance.posY',
        posZ: 'cubeData.moduleInstance.posZ',
        boxWallWidth: 'cubeData.moduleInstance.boxWallWidth',
        boxWallHeight: 'cubeData.moduleInstance.boxWallHeight',
        boxWallDepth: 'cubeData.moduleInstance.boxWallDepth',
        layerHeight: 'cubeData.moduleInstance.layerHeight',
        slope: 'cubeData.moduleInstance.slope',
        moduleColor: 'cubeData.moduleInstance.moduleColor',
        gratingHeight: 'cubeData.moduleInstance.gratingHeight',
        unitType: 'cubeData.moduleInstance.unitType',
        specialAttr: "cubeData.moduleInstance.specialAttr",
        warningEnumSet: "cubeData.moduleInstance.warningEnumSet",
        moduleTypeName: "cubeData.moduleInstance.moduleTypeName",
        shopExecuteFlag: "cubeData.moduleInstance.shopExecuteFlag",
        dragMode: "cubeData.moduleInstance.dragMode",
        recheckFlag: "cubeData.moduleInstance.recheckFlag",

        //空间
        arrangeHeight: 'cubeData.moduleInstance.arrangeHeight',
        weightCapacity: 'cubeData.moduleInstance.weightCapacity',
        combinationType: 'cubeData.moduleInstance.combinationType',
        partitionSpacing: 'cubeData.moduleInstance.partitionSpacing',
        partitionWidth: 'cubeData.moduleInstance.partitionWidth',
        partitionHeight: 'cubeData.moduleInstance.partitionHeight',
        partitionDepth: 'cubeData.moduleInstance.partitionDepth',
        partitionPos: 'cubeData.moduleInstance.partitionPos',
        extendLeft: 'cubeData.moduleInstance.extendLeft',
        extendRight: 'cubeData.moduleInstance.extendRight',
        extendBack: 'cubeData.moduleInstance.extendBack',
        extendFront: 'cubeData.moduleInstance.extendFront',
        usePartition: 'cubeData.moduleInstance.usePartition',

        //X
        xdirection: 'cubeData.moduleInstance.xdirection',
        xplaceType: 'cubeData.moduleInstance.xplaceType',
        xsurfaceType: 'cubeData.moduleInstance.xsurfaceType',
        xsurfaceWidthType: 'cubeData.moduleInstance.xsurfaceWidthType',
        xminSurfaceType: 'cubeData.moduleInstance.xminSurfaceType',
        xminSurfaceNum: 'cubeData.moduleInstance.xminSurfaceNum',
        xmaxSurfaceType: 'cubeData.moduleInstance.xmaxSurfaceType',
        xmaxSurfaceNum: 'cubeData.moduleInstance.xmaxSurfaceNum',
        xtargetSurfaceType: 'cubeData.moduleInstance.xtargetSurfaceType',
        xtargetSurfaceNum: 'cubeData.moduleInstance.xtargetSurfaceNum',
        xtargetPileType: 'cubeData.moduleInstance.xtargetPileType',
        xtargetPileNum: 'cubeData.moduleInstance.xtargetPileNum',

        //Y
        ydirection: 'cubeData.moduleInstance.ydirection',
        yplaceType: 'cubeData.moduleInstance.yplaceType',
        ysurfaceType: 'cubeData.moduleInstance.ysurfaceType',
        ysurfaceWidthType: 'cubeData.moduleInstance.ysurfaceWidthType',
        yminSurfaceType: 'cubeData.moduleInstance.yminSurfaceType',
        yminSurfaceNum: 'cubeData.moduleInstance.yminSurfaceNum',
        ymaxSurfaceType: 'cubeData.moduleInstance.ymaxSurfaceType',
        ymaxSurfaceNum: 'cubeData.moduleInstance.ymaxSurfaceNum',
        ytargetSurfaceType: 'cubeData.moduleInstance.ytargetSurfaceType',
        ytargetSurfaceNum: 'cubeData.moduleInstance.ytargetSurfaceNum',
        ytargetPileType: 'cubeData.moduleInstance.ytargetPileType',
        ytargetPileNum: 'cubeData.moduleInstance.ytargetPileNum',

        //Z
        zdirection: "cubeData.moduleInstance.zdirection",
        zplaceType: "cubeData.moduleInstance.zplaceType",
        zsurfaceType: "cubeData.moduleInstance.zsurfaceType",
        zsurfaceWidthType: "cubeData.moduleInstance.zsurfaceWidthType",
        zminSurfaceType: "cubeData.moduleInstance.zminSurfaceType",
        zminSurfaceNum: "cubeData.moduleInstance.zminSurfaceNum",
        zmaxSurfaceType: "cubeData.moduleInstance.zmaxSurfaceType",
        zmaxSurfaceNum: "cubeData.moduleInstance.zmaxSurfaceNum",
        ztargetSurfaceType: "cubeData.moduleInstance.ztargetSurfaceType",
        ztargetSurfaceNum: "cubeData.moduleInstance.ztargetSurfaceNum",
        ztargetPileType: "cubeData.moduleInstance.ztargetPileType",
        ztargetPileNum: "cubeData.moduleInstance.ztargetPileNum"
    },
    layerDefaultKeyMap: {
        unitType: 'cubeData.moduleDefaultValue.unitType',
        combinationType: 'cubeData.moduleDefaultValue.combinationType',
        xplaceType: 'cubeData.moduleDefaultValue.xplaceType',
        xdirection: 'cubeData.moduleDefaultValue.xdirection',
        xsurfaceType: 'cubeData.moduleDefaultValue.xsurfaceType',
        xsurfaceWidthType: 'cubeData.moduleDefaultValue.xsurfaceWidthType',
        xmaxSurfaceType: 'cubeData.moduleDefaultValue.xmaxSurfaceType',
        xtargetSurfaceType: 'cubeData.moduleDefaultValue.xtargetSurfaceType',
        xtargetPileType: 'cubeData.moduleDefaultValue.xtargetPileType',
        yplaceType: 'cubeData.moduleDefaultValue.yplaceType',
        ydirection: 'cubeData.moduleDefaultValue.ydirection',
        ysurfaceType: 'cubeData.moduleDefaultValue.ysurfaceType',
        ysurfaceWidthType: 'cubeData.moduleDefaultValue.ysurfaceWidthType',
        yminSurfaceType: 'cubeData.moduleDefaultValue.yminSurfaceType',
        ymaxSurfaceType: 'cubeData.moduleDefaultValue.ymaxSurfaceType',
        ytargetSurfaceType: 'cubeData.moduleDefaultValue.ytargetSurfaceType',
        ytargetPileType: 'cubeData.moduleDefaultValue.ytargetPileType',
        zplaceType: 'cubeData.moduleDefaultValue.zplaceType',
        zdirection: 'cubeData.moduleDefaultValue.zdirection',
        zsurfaceType: 'cubeData.moduleDefaultValue.zsurfaceType',
        zsurfaceWidthType: 'cubeData.moduleDefaultValue.zsurfaceWidthType',
        zminSurfaceType: 'cubeData.moduleDefaultValue.zminSurfaceType',
        zmaxSurfaceType: 'cubeData.moduleDefaultValue.zmaxSurfaceType',
        ztargetSurfaceType: 'cubeData.moduleDefaultValue.ztargetSurfaceType',
        ztargetPileType: 'cubeData.moduleDefaultValue.ztargetPileType'
    }
};

export default layerConfig;
